import React from 'react'

import Base from '../_Base'

const Sort = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M9 18a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zm6-7a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zm6-7a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2z"
      fillRule="evenodd"
    />
  </Base>
)

export default Sort
